export const isValidIntegerId = (int) => Number.isInteger(int) && int >= 0;
let integerIdSequence = 0;
export const fromSequence = () => integerIdSequence++;
